<template>
  <w-td sticky="right" align="center" justify="center" class="w-td-actions">
    <w-tooltip text="Usuń wiersz" :delay="0.5">
      <w-button
        v-if="deleteRow"
        variant="tonal"
        size="xs"
        color="danger"
        icon="delete"
        @click="removeRow"
      />
    </w-tooltip>

    <w-tooltip text="Zamień miejscami" class="w-td-actions__swap" :delay="0.5">
      <w-button v-if="canMoveUp" size="xs" icon="swap_vert" @click="moveRowUp" />
    </w-tooltip>
  </w-td>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { confirmService } from '../../services/confirm.service';

const {
  model,
  confirmDeleteMessage = 'Czy jesteś pewien/a, że chcesz usunąć ten wiersz?',
  deleteRow = true,
  moveUp = undefined,
} = defineProps<{
  /**
   * Model pojedynczego wiersza tablicy, który będzie modyfikowany przez przyciski akcji.
   */
  model: any;

  /**
   * Wiadomość wyświetlana w oknie potwierdzenia przed usunięciem wiersza. Domyślnie "Czy jesteś pewien/a, że chcesz usunąć ten wiersz?".
   */
  confirmDeleteMessage?: string;

  /**
   * Flaga określająca, czy przycisk usuwania ma być widoczny.
   */
  deleteRow?: boolean;

  /**
   * Flaga określająca, czy przycisk przesuwania wiersza w górę ma być widoczny.
   */
  moveUp?: boolean;

  /**
   * Flaga określająca, czy przycisk przesuwania wiersza w dół ma być widoczny.
   */
  moveDown?: boolean;
}>();

const index = computed(() =>
  model.$parent.$items.findIndex((item: { $item: any }) => item.$item === model),
);

const canMoveUp = computed(() => (moveUp !== undefined ? moveUp : index.value > 0));

const emit = defineEmits<{
  rowDeleted: [];
  rowMovedUp: [model: any];
  rowMovedDown: [model: any];
}>();

function moveRowUp() {
  model.$moveUp();
  emit('rowMovedUp', model);
}

function removeRow() {
  confirmService
    .confirm(confirmDeleteMessage)
    .then(() => {
      model.$removeRow();
      emit('rowDeleted');
    })
    .catch(() => {
      // Użytkownik anulował usunięcie
    });
}
</script>

<style lang="scss">
.w-td-actions {
  .w-td__content {
    min-height: 40px;
  }

  &__swap {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
